const tab_cart = () =>
    import ( /* webpackChunkName: "tabbar-cart" */ '@/views/order/tabbar-cart.vue');
const PlaceOrderEntity = () =>
    import( /* webpackChunkName: "placerder-entity" */ '@/views/order/place-order-entity/');
const PlaceOrderTicket = () =>
    import ( /* webpackChunkName: "placerder-ticket" */ '@/views/order/place-order-ticket/');
const PlaceOrderVirtual = () =>
    import ( /* webpackChunkName: "placeOrder-virtual" */ '@/views/order/place-order-virtual/');
const Payment = () =>
    import ( /* webpackChunkName: "payment" */ '@/views/order/payment/');
const PaymentStatus = () =>
    import ( /* webpackChunkName: "payment-status" */ '@/views/order/payment-status/');
const PaymentDuiGongStatus = () =>
    import ( /* webpackChunkName: "payment-duigong-status" */ '@/views/order/payment-duigong-status/');

const Tabbar = () =>
    import ( /* webpackChunkName: "Tabbar" */ '@/vue/components/Tabbar/');
const Subscriptions = () =>
    import ( /* webpackChunkName: "subscriptions" */ '@/views/order/subscriptions/index.vue');

export default [{
    path: "/order",
    name: "cart",
    components: { default: tab_cart, tabbar: Tabbar },
    meta: {
        title: "购物车"
    }
}, {
    path: "/order/placeOrderEntity",
    name: "placeOrderEntity",
    meta: {
        keepAlive: true,
        hideMenu: true,
        title: "提交订单"
    },
    component: PlaceOrderEntity
}, {
    path: "/order/placeOrderVirtual",
    name: "placeOrderVirtual",
    meta: {
        hideMenu: true,
        title: "提交订单"
    },
    component: PlaceOrderVirtual
}, {
    path: "/order/placeOrderTicket",
    name: "placeOrderTicket",
    meta: {
        keepAlive: true,
        hideMenu: true,
        title: "提交订单"
    },
    component: PlaceOrderTicket
}, {
    path: "/order/payment/:order_id",
    name: "payment",
    meta: {
        hideMenu: true,
        title: "订单支付"
    },
    component: Payment
}, {
    path: "/order/paymentstatus/:id",
    name: "paymentStatus",
    meta: {
        title: "支付结果"
    },
    component: PaymentStatus,
    props: true
}, {
    path: "/order/duigong/paymentstatus/:id",
    name: 'paymentDuiGongStatus',
    meta: {
        title: "对公支付结果"
    },
    component: PaymentDuiGongStatus
}, {
    path: "/order/subscriptions",
    name: 'subscriptions',
    meta: {
        hideMenu: true,
        title: "订阅"
    },
    component: Subscriptions
},
{
    path: "/order/paymentloading",
    name: "paymentLoading",
    meta: {
        title: "支付中"
    },
    component: () => import("@/views/order/payment/loading.vue")
}]
